/**
 * Assessment form multi-step logic.
 * Finds all assessment form config elements (script#assessment-form-config-*) and inits each form.
 */
(function() {
	function initForm(configEl) {
		var config = { formId: 'assessment-form', step3Images: {}, strings: {} };
		var formId = configEl.id.replace('assessment-form-config-', '');
		if (formId) config.formId = formId;
		if (configEl.textContent) {
			try {
				config = JSON.parse(configEl.textContent);
			} catch (e) {}
		}

		var form = document.getElementById(config.formId);
		if (!form) return;

		/* ── Phone input ─────────────────────────────────────────── */
		var _phoneInput = document.getElementById('assessment_contact_number');
		var _isoInput   = document.getElementById('assessment_contact_iso');
		var assessmentPhoneIti = null;
		if (typeof CA_Phone !== 'undefined' && _phoneInput) {
			assessmentPhoneIti = CA_Phone.init({
				phoneInput : _phoneInput,
				isoInput   : _isoInput,
				formEl     : form,
			});
		}

		var wrapper = form.closest('.ca-assessment-form');
		var messageEl = wrapper ? wrapper.querySelector('.assessment-form-message') : null;
		var successEl = wrapper ? wrapper.querySelector('.assessment-form-success') : null;
		var steps = wrapper ? wrapper.querySelectorAll('.assessment-step') : [];
		var interestInput = document.getElementById('assessment_interest_input');
		var step3DataInput = document.getElementById('assessment_step3_data_input');
		var currentStep = 1;
		var selectedInterest = '';

		/** Remove required from hidden Step 3 panels so native validation doesn't run on them on submit. */
		function updateStep3Required() {
			if (!wrapper) return;
			var step3Panels = wrapper.querySelectorAll('.assessment-step3');
			var isVisible = function(panel) {
				return currentStep === 3 && panel.getAttribute('data-interest') === selectedInterest;
			};
			step3Panels.forEach(function(panel) {
				var visible = isVisible(panel);
				panel.querySelectorAll('[name^="step3_"]').forEach(function(el) {
					if (el.tagName !== 'INPUT' && el.tagName !== 'SELECT' && el.tagName !== 'TEXTAREA') return;
					if (visible) {
						if (el.getAttribute('data-step3-required') === '1') {
							el.setAttribute('required', 'required');
							el.removeAttribute('data-step3-required');
						}
					} else {
						if (el.hasAttribute('required')) {
							el.setAttribute('data-step3-required', '1');
							el.removeAttribute('required');
						}
					}
				});
			});
		}

		function showStep(step) {
			currentStep = step;
			steps.forEach(function(s) {
				var sNum = parseInt(s.getAttribute('data-step'), 10);
				if (sNum === step) {
					s.classList.remove('hidden');
					s.classList.add('flex');
				} else {
					s.classList.add('hidden');
					s.classList.remove('flex');
				}
			});
			if (step === 3) {
				if (wrapper) {
					wrapper.querySelectorAll('.assessment-step3').forEach(function(panel) {
						if (panel.getAttribute('data-interest') === selectedInterest) {
							panel.classList.remove('hidden');
							panel.classList.add('flex');
						} else {
							panel.classList.add('hidden');
							panel.classList.remove('flex');
						}
					});
				}
				// Toggle spouse fields in Step 3 based on marital status
				toggleStep3SpouseFields();
			}
			updateStep3Required();
		}

		// Handle conditional Step 3 spouse fields
		function toggleStep3SpouseFields() {
			if (!wrapper) return;
			
			var marriedRadio = form.querySelector('[name="assessment_married_common_law"]:checked');
			var isMarried = marriedRadio && marriedRadio.value === 'Yes';
			var spouseFieldsContainers = wrapper.querySelectorAll('.js-step3-spouse-fields');
			var spouseFields = wrapper.querySelectorAll('.js-step3-spouse-field');
			
			spouseFieldsContainers.forEach(function(container) {
				if (isMarried) {
					container.classList.remove('hidden');
					// Add required to all spouse fields
					container.querySelectorAll('input[type="text"], input[type="radio"], select').forEach(function(field) {
						if (field.name && field.name.startsWith('step3_spouse_')) {
							field.setAttribute('required', 'required');
						}
					});
				} else {
					container.classList.add('hidden');
					// Remove required from all spouse fields
					container.querySelectorAll('input[type="text"], input[type="radio"], select').forEach(function(field) {
						if (field.name && field.name.startsWith('step3_spouse_')) {
							field.removeAttribute('required');
						}
					});
					// Clear values
					container.querySelectorAll('input[type="text"], select').forEach(function(field) {
						if (field.name && field.name.startsWith('step3_spouse_')) {
							field.value = '';
						}
					});
					container.querySelectorAll('input[type="radio"]').forEach(function(field) {
						if (field.name && field.name.startsWith('step3_spouse_')) {
							field.checked = false;
						}
					});
				}
			});
		}

		function showMessage(text, isError) {
			if (messageEl) {
				messageEl.textContent = text;
				messageEl.classList.toggle('hidden', !isError);
				messageEl.classList.toggle('border-red-200', isError);
				messageEl.classList.toggle('bg-red-50', isError);
			}
			if (successEl) successEl.classList.add('hidden');
		}

		var errorClass = 'assessment-field-error';

		function clearFieldErrors() {
			if (!wrapper) return;
			wrapper.querySelectorAll('.' + errorClass).forEach(function (el) {
				el.classList.remove(errorClass);
			});
		}

		function markFieldError(controlOrWrapper) {
			if (!controlOrWrapper) return;
			var wrapperEl = controlOrWrapper.closest('.form-field') || controlOrWrapper.closest('fieldset') || controlOrWrapper.closest('div[id="assessment_interest_group"]') || controlOrWrapper.parentElement;
			if (wrapperEl) wrapperEl.classList.add(errorClass);
		}

		function scrollToFirstInvalid(firstInvalidControlOrWrapper) {
			if (!firstInvalidControlOrWrapper) return;
			var scrollTarget = firstInvalidControlOrWrapper.closest('.form-field') || firstInvalidControlOrWrapper.closest('fieldset') || firstInvalidControlOrWrapper.closest('div[id="assessment_interest_group"]') || firstInvalidControlOrWrapper;
			if (scrollTarget && scrollTarget.scrollIntoView) {
				scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		}

		function validateStep1() {
			var invalid = [];
			var first = form.querySelector('[name="assessment_first_name"]');
			var last = form.querySelector('[name="assessment_last_name"]');
			var email = form.querySelector('[name="assessment_email"]');
			var contact = form.querySelector('[name="assessment_contact_number"]');
			var countryRes = form.querySelector('[name="assessment_country_residence"]');
			var passport = form.querySelector('[name="assessment_passport_country"]');
			var age = form.querySelector('[name="assessment_age"]');
			var married = form.querySelector('[name="assessment_married_common_law"]:checked');
			if (!first || !first.value.trim()) invalid.push(first);
			if (!last || !last.value.trim()) invalid.push(last);
			if (!email || !email.value.trim()) invalid.push(email);
			if (!contact || !contact.value.trim()) invalid.push(contact);
			if (!countryRes || !countryRes.value) invalid.push(countryRes);
			if (!passport || !passport.value) invalid.push(passport);
			if (!age || !age.value) invalid.push(age);
			if (!married) {
				var marriedField = form.querySelector('[name="assessment_married_common_law"]');
				if (marriedField) invalid.push(marriedField.closest('fieldset'));
			}
			// Check spouse citizenship field if visible
			var spouseField = wrapper ? wrapper.querySelector('.js-spouse-citizenship-field') : null;
			if (spouseField && !spouseField.classList.contains('hidden')) {
				var spouseCitizen = form.querySelector('[name="assessment_spouse_citizen_pr"]:checked');
				if (!spouseCitizen) {
					var spouseFieldset = form.querySelector('.js-spouse-citizenship-radio-group');
					if (spouseFieldset) invalid.push(spouseFieldset);
				} else if (spouseCitizen.value === 'Yes') {
					// Check spouse details fields if spouse is citizen/PR
					var detailsFields = wrapper ? wrapper.querySelector('.js-spouse-details-fields') : null;
					if (detailsFields && !detailsFields.classList.contains('hidden')) {
						var residingWith = form.querySelector('[name="assessment_residing_with_spouse"]:checked');
						var spouseInCanada = form.querySelector('[name="assessment_spouse_residing_canada"]:checked');
						var marriageDuration = form.querySelector('[name="assessment_marriage_duration"]:checked');
						
						if (!residingWith) {
							var residingFieldset = form.querySelector('[name="assessment_residing_with_spouse"]').closest('fieldset');
							if (residingFieldset) invalid.push(residingFieldset);
						}
						if (!spouseInCanada) {
							var inCanadaFieldset = form.querySelector('[name="assessment_spouse_residing_canada"]').closest('fieldset');
							if (inCanadaFieldset) invalid.push(inCanadaFieldset);
						}
						if (!marriageDuration) {
							var durationFieldset = form.querySelector('[name="assessment_marriage_duration"]').closest('fieldset');
							if (durationFieldset) invalid.push(durationFieldset);
						}
					}
				}
			}
			invalid = invalid.filter(Boolean);
			return { valid: invalid.length === 0, firstInvalid: invalid[0], invalid: invalid };
		}

		function validateStep2() {
			var radio = form.querySelector('[name="assessment_interest_radio"]:checked');
			var group = document.getElementById('assessment_interest_group');
			if (!radio && group) {
				return { valid: false, firstInvalid: group, invalid: [group] };
			}
			return { valid: true, firstInvalid: null, invalid: [] };
		}

		function validateStep3() {
			var invalid = [];
			var panel = wrapper ? wrapper.querySelector('.assessment-step3[data-interest="' + selectedInterest + '"]') : null;
			if (!panel) return { valid: true, firstInvalid: null, invalid: [] };
			var requiredRadioNames = {};
			// Check if spouse fields should be validated
			var marriedRadio = form.querySelector('[name="assessment_married_common_law"]:checked');
			var isMarried = marriedRadio && marriedRadio.value === 'Yes';
			
			panel.querySelectorAll('[name^="step3_"]').forEach(function(el) {
				if (el.tagName !== 'INPUT' && el.tagName !== 'SELECT' && el.tagName !== 'TEXTAREA') return;
				var name = el.getAttribute('name');
				if (!name) return;
				// Skip spouse fields if not married
				if (name.startsWith('step3_spouse_') && !isMarried) return;
				var isRequired = el.hasAttribute('required') || el.getAttribute('data-step3-required') === '1';
				if (!isRequired) return;
				if (el.type === 'radio') {
					requiredRadioNames[name] = requiredRadioNames[name] || [];
					requiredRadioNames[name].push(el);
				} else if (el.type !== 'checkbox') {
					var val = (el.value || '').trim();
					if (val === '') invalid.push(el);
				}
			});
			Object.keys(requiredRadioNames).forEach(function(name) {
				// Skip spouse fields if not married
				if (name.startsWith('step3_spouse_') && !isMarried) return;
				var checked = panel.querySelector('[name="' + name + '"]:checked');
				if (!checked) invalid.push(requiredRadioNames[name][0]);
			});
			invalid = invalid.filter(Boolean);
			return { valid: invalid.length === 0, firstInvalid: invalid[0], invalid: invalid };
		}

		function scrollToFormTop() {
			if (!wrapper) return;
			var top = wrapper.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
			var scrollTarget = Math.max(0, top - 100);
			window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
		}

		function showSuccess(inquiryNumber, message) {
			if (messageEl) messageEl.classList.add('hidden');
			if (successEl) {
				var refLabel = (config.strings.your_reference_number || 'Your reference number');
				var detail = (config.strings.success_detail || 'We\'ve received your assessment. Our team will review your information and be in touch if we need anything else.');
				var numberBlock = inquiryNumber
					? '<p class="assessment-success-ref-label">' + escapeHtml(refLabel) + '</p><p class="assessment-success-ref-number">' + escapeHtml(inquiryNumber) + '</p>'
					: '';
				successEl.innerHTML =
					'<div class="assessment-success-icon" aria-hidden="true">✓</div>' +
					(numberBlock ? '<div class="assessment-success-inquiry">' + numberBlock + '</div>' : '') +
					'<p class="assessment-success-message">' + (message ? escapeHtml(message) : '') + '</p>' +
					'<p class="assessment-success-detail">' + escapeHtml(detail) + '</p>';
				successEl.classList.remove('hidden');
			}
			if (wrapper) wrapper.classList.add('assessment-form-success-view');
			if (successEl && successEl.scrollIntoView) {
				setTimeout(function() {
					successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}, 100);
			}
		}

		function escapeHtml(str) {
			if (str == null) return '';
			var div = document.createElement('div');
			div.textContent = str;
			return div.innerHTML;
		}

		if (wrapper) {
			wrapper.querySelectorAll('.assessment-next').forEach(function(btn) {
				btn.addEventListener('click', function() {
					var next = parseInt(this.getAttribute('data-next'), 10);
					clearFieldErrors();
					if (next === 2) {
						var step1 = validateStep1();
						if (!step1.valid) {
							step1.invalid.forEach(function(el) { markFieldError(el); });
							showMessage(config.strings.please_fill_required || 'Please fill in all required fields.', true);
							scrollToFirstInvalid(step1.firstInvalid);
							return;
						}
					}
					if (next === 3) {
						var step2 = validateStep2();
						if (!step2.valid) {
							step2.invalid.forEach(function(el) { markFieldError(el); });
							showMessage(config.strings.please_interest || 'Please select an interest.', true);
							scrollToFirstInvalid(step2.firstInvalid);
							return;
						}
						selectedInterest = form.querySelector('[name="assessment_interest_radio"]:checked').value;
						if (interestInput) interestInput.value = selectedInterest;
						if (selectedInterest === 'married_to_canadian') {
							showMessage('', false);
							showStep(4);
							scrollToFormTop();
							return;
						}
					}
					if (next === 4 && currentStep === 3) {
						var step3 = validateStep3();
						if (!step3.valid) {
							step3.invalid.forEach(function(el) { markFieldError(el); });
							showMessage(config.strings.please_fill_required || 'Please fill in all required fields.', true);
							scrollToFirstInvalid(step3.firstInvalid);
							return;
						}
					}
					showMessage('', false);
					showStep(next);
					scrollToFormTop();
				});
			});

			wrapper.querySelectorAll('.assessment-prev').forEach(function(btn) {
				btn.addEventListener('click', function() {
					var prev = parseInt(this.getAttribute('data-prev'), 10);
					// If going back from Step 4 and interest is "married_to_canadian", go to Step 2 instead of Step 3
					if (prev === 3 && currentStep === 4 && selectedInterest === 'married_to_canadian') {
						prev = 2;
					}
					clearFieldErrors();
					showMessage('', false);
					showStep(prev);
					scrollToFormTop();
				});
			});
		}

		function getStep3Data() {
			var data = {};
			if (!wrapper) return data;
			var panel = wrapper.querySelector('.assessment-step3[data-interest="' + selectedInterest + '"]');
			if (!panel) return data;
			panel.querySelectorAll('[name^="step3_"]').forEach(function(el) {
				var name = el.getAttribute('name').replace('step3_', '');
				if (el.type === 'radio') {
					if (el.checked) data[name] = el.value;
				} else if (el.type === 'checkbox') {
					if (name.indexOf('[]') !== -1) {
						var key = name.replace('[]', '');
						if (!data[key]) data[key] = [];
						if (el.checked) data[key].push(el.value);
					} else {
						data[name] = el.checked ? '1' : '0';
					}
				} else {
					data[name] = el.value;
				}
			});
			return data;
		}

		function showSpinner() {
			var submitBtn = form.querySelector('.js-assessment-submit');
			if (!submitBtn) return;
			var btnText = submitBtn.querySelector('.btn-text');
			if (btnText && !submitBtn.querySelector('.assessment-form-spinner')) {
				var spinner = document.createElement('span');
				spinner.className = 'assessment-form-spinner';
				spinner.setAttribute('aria-hidden', 'true');
				btnText.insertAdjacentElement('beforebegin', spinner);
			}
		}
		function hideSpinner() {
			var submitBtn = form.querySelector('.js-assessment-submit');
			if (!submitBtn) return;
			var spinner = submitBtn.querySelector('.assessment-form-spinner');
			if (spinner) {
				spinner.remove();
			}
		}

		function syncAssessmentPhoneE164() {
			if (!_phoneInput || !assessmentPhoneIti || typeof assessmentPhoneIti.getNumber !== 'function') {
				return;
			}
			if (String(_phoneInput.value || '').trim() === '') {
				return;
			}
			try {
				var e164 = assessmentPhoneIti.getNumber();
				if (e164) {
					_phoneInput.value = e164;
				}
			} catch (err) {}
		}

		form.addEventListener('submit', function(e) {
			e.preventDefault();
			clearFieldErrors();
			showMessage('', false);
			var newsletter = form.querySelector('[name="assessment_newsletter"]:checked');
			if (!newsletter) {
				var newsletterField = form.querySelector('[name="assessment_newsletter"]');
				if (newsletterField) {
					markFieldError(newsletterField);
					scrollToFirstInvalid(newsletterField);
				}
				showMessage(config.strings.please_newsletter || 'Please select newsletter preference.', true);
				return;
			}
			if (step3DataInput) step3DataInput.value = JSON.stringify(selectedInterest === 'married_to_canadian' ? {} : getStep3Data());

			var submitBtn = form.querySelector('.js-assessment-submit');
			if (submitBtn) {
				submitBtn.disabled = true;
				showSpinner();
			}

			syncAssessmentPhoneE164();
			var body = new FormData(form);
			body.append('action', form.getAttribute('data-action'));

			fetch(form.getAttribute('data-ajax-url'), { method: 'POST', body: body, credentials: 'same-origin' })
				.then(function(r) { return r.json(); })
				.then(function(res) {
					if (res.success && res.data && res.data.message) {
						var inquiryNum = (res.data.inquiry_number || '');
						showSuccess(inquiryNum, res.data.message);
						form.reset();
						showStep(1);
						selectedInterest = '';
						if (interestInput) interestInput.value = '';
						// Reset conditional spouse citizenship field
						toggleSpouseCitizenshipField();
						// Reset spouse details fields
						toggleSpouseDetailsFields(false);
						// Reset Step 3 spouse fields
						toggleStep3SpouseFields();
					} else {
						showMessage((res.data && res.data.message) ? res.data.message : (config.strings.something_wrong || 'Something went wrong. Please try again.'), true);
					}
				})
				.catch(function() {
					showMessage(config.strings.something_wrong || 'Something went wrong. Please try again.', true);
				})
				.finally(function() {
					if (submitBtn) {
						submitBtn.disabled = false;
						hideSpinner();
					}
				});
		});

		form.addEventListener('input', function(e) {
			var target = e.target;
			if (!target || !target.name) return;
			var w = target.closest('.form-field') || target.closest('fieldset') || target.closest('#assessment_interest_group');
			if (w && w.classList.contains(errorClass)) w.classList.remove(errorClass);
		});
		form.addEventListener('change', function(e) {
			var target = e.target;
			if (!target || !target.name) return;
			var w = target.closest('.form-field') || target.closest('fieldset') || target.closest('#assessment_interest_group');
			if (w && w.classList.contains(errorClass)) w.classList.remove(errorClass);
		});

		// Handle conditional spouse citizenship field
		function toggleSpouseCitizenshipField() {
			var spouseField = wrapper ? wrapper.querySelector('.js-spouse-citizenship-field') : null;
			if (!spouseField) return;
			
			var marriedRadio = form.querySelector('[name="assessment_married_common_law"]:checked');
			var isMarried = marriedRadio && marriedRadio.value === 'Yes';
			var spouseRadios = form.querySelectorAll('[name="assessment_spouse_citizen_pr"]');
			var spouseFieldset = form.querySelector('.js-spouse-citizenship-radio-group');
			
			if (isMarried) {
				spouseField.classList.remove('hidden');
				// Add required to radio buttons
				spouseRadios.forEach(function(radio) {
					radio.setAttribute('required', 'required');
				});
			} else {
				spouseField.classList.add('hidden');
				// Remove required from radio buttons
				spouseRadios.forEach(function(radio) {
					radio.removeAttribute('required');
				});
				// Clear selected value
				spouseRadios.forEach(function(radio) {
					radio.checked = false;
				});
				// Clear error state
				if (spouseFieldset && spouseFieldset.classList.contains(errorClass)) {
					spouseFieldset.classList.remove(errorClass);
				}
				// Hide and clear spouse details fields
				toggleSpouseDetailsFields(false);
			}
		}

		// Handle conditional spouse details fields (shown when spouse is citizen/PR)
		function toggleSpouseDetailsFields(show) {
			var detailsFields = wrapper ? wrapper.querySelector('.js-spouse-details-fields') : null;
			if (!detailsFields) return;
			
			var detailRadios = form.querySelectorAll('.js-spouse-detail-field input[type="radio"]');
			var detailFieldsets = form.querySelectorAll('.js-spouse-detail-field');
			
			if (show) {
				detailsFields.classList.remove('hidden');
				// Add required to all radio buttons in detail fields
				detailRadios.forEach(function(radio) {
					radio.setAttribute('required', 'required');
				});
			} else {
				detailsFields.classList.add('hidden');
				// Remove required from radio buttons
				detailRadios.forEach(function(radio) {
					radio.removeAttribute('required');
				});
				// Clear selected values
				detailRadios.forEach(function(radio) {
					radio.checked = false;
				});
				// Clear error states
				detailFieldsets.forEach(function(fieldset) {
					if (fieldset.classList.contains(errorClass)) {
						fieldset.classList.remove(errorClass);
					}
				});
			}
		}

		// Listen for changes to marital status
		form.querySelectorAll('[name="assessment_married_common_law"]').forEach(function(radio) {
			radio.addEventListener('change', function() {
				toggleSpouseCitizenshipField();
				// Also update Step 3 spouse fields if we're on Step 3
				if (currentStep === 3) {
					toggleStep3SpouseFields();
				}
			});
		});

		// Listen for changes to spouse citizenship
		form.querySelectorAll('[name="assessment_spouse_citizen_pr"]').forEach(function(radio) {
			radio.addEventListener('change', function() {
				var checkedRadio = form.querySelector('[name="assessment_spouse_citizen_pr"]:checked');
				var isCitizenPR = checkedRadio && checkedRadio.value === 'Yes';
				toggleSpouseDetailsFields(isCitizenPR);
			});
		});

		// Initialize on load
		toggleSpouseCitizenshipField();
		// Check if spouse citizenship is already "Yes" on load
		var spouseCitizenChecked = form.querySelector('[name="assessment_spouse_citizen_pr"]:checked');
		if (spouseCitizenChecked && spouseCitizenChecked.value === 'Yes') {
			toggleSpouseDetailsFields(true);
		}

		// On load we're on step 1; remove required from all Step 3 fields so submit from step 4 doesn't validate them.
		updateStep3Required();
	}

	function run() {
		var configEls = document.querySelectorAll('script[id^="assessment-form-config-"]');
		configEls.forEach(function(el) { initForm(el); });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
})();
